import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { initialUiState, type ModalPayload, type UiConfirmState } from '@/types/shared/ui.types';

export const uiSlice = createSlice({
  name: 'ui',
  initialState: initialUiState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalPayload>) => {
      state.modal = action.payload.modal;
      state.modalProps = action.payload.modalProps;
    },
    closeModal: (state) => {
      state.modal = null;
      state.modalProps = undefined;
    },
    setShowLoader: (state) => {
      state.showLoader = true;
    },
    setHideLoader: (state) => {
      state.showLoader = false;
    },
    setErrorMessage: (state, action: PayloadAction<string | null>) => {
      state.errorMessage = action.payload;
    },

    openConfirm: (state, action: PayloadAction<UiConfirmState>) => {
      state.confirm = action.payload;
    },
    closeConfirm: (state) => {
      state.confirm = null;
    },

    setPollingSuccess: (
      state,
      action: PayloadAction<{ title: string; message: string; resourceUrl?: string | null }>
    ) => {
      state.pollingModal = {
        type: 'success',
        title: action.payload.title,
        message: action.payload.message,
        resourceUrl: action.payload.resourceUrl ?? null,
        details: null,
      };
    },
    setPollingError: (
      state,
      action: PayloadAction<{ title: string; message: string; details?: Record<string, unknown> | null }>
    ) => {
      state.pollingModal = {
        type: 'error',
        title: action.payload.title,
        message: action.payload.message,
        resourceUrl: null,
        details: action.payload.details ?? null,
      };
    },
    clearPollingModal: (state) => {
      state.pollingModal = { type: null };
    },
  },
});

export const {
  openModal,
  closeModal,
  setShowLoader,
  setHideLoader,
  setErrorMessage,
  openConfirm,
  closeConfirm,
  setPollingSuccess,
  setPollingError,
  clearPollingModal,
} = uiSlice.actions;

export default uiSlice.reducer;
